import React, {useEffect, useRef, useState} from "react";
import classNames from "classnames";
import {useInView} from "react-intersection-observer";
import {useSwipeable} from "react-swipeable";
import {dataLayerPush, declOfNum} from "@/Helpers/Function";
import {useBasketStore} from "@/Stores/Site/Basket";
import {useAddToWaitList} from "@/features/profile/model/useAddToWaitList";
import {useAddToBasket} from "@/features/basketActions/model/useAddToBasket";
import {useQuickView} from "@/features/quickView/model/useQuickView";
import PriceMinimum from "@/Pages/All/PriceMinimum";
import Link from "@/Layouts/Link";
import Svg from "@/Components/Svg";
import BasketButton from "@/Components/Site/BasketButton";
import FavoritesCheckbox from "@/Components/Site/FavoritesCheckbox";
import Picture from "@/Components/Picture";
import "@/Scss/Components/catalogCard.scss";

const CatalogCard = (props) => {
    const {index = 0, el = {}, className = '', type = '', registerView} = props;
    const {img_card = '', img = '', ratingAVG = null} = el;

    const basketProducts = useBasketStore(state => state.basketProducts);

    const {addToBasket, loading: isAddingToBasket} = useAddToBasket();
    const {addToWaitList, loading: isAddingToWaitList} = useAddToWaitList();
    const {openQuickView} = useQuickView();

    const {ref, inView} = useInView({
        threshold: 1, // Число между 0 и 1 указывает процент, который должен быть виден перед срабатыванием.
        triggerOnce: true,
    });

    useEffect(() => {
        if (registerView && inView) registerView({...el, index: index});
    }, [inView, el, registerView]);

    // Текущая цена для отправки в аналитику
    const currentPrice = el.minimumPrice !== 0 ? el.minimumPrice : el.card_price;

    const media = (img_card ?? img).split(";").map(url => url.replace(/\.png/g, ".webp"));

    const handleItemClick = () => {
        dataLayerPush('select_item', 'catalog', 'selectItem', 'product', '',
            [{
                ...el,
                'product_id': el.id,
                'count': 1,
                'price': currentPrice,
            }]
        );
    }

    const cardPrice = () => {
        if (el.card_price !== el.price) {
            return <div className={`catalogCard__priceContainer`}>
                <span className={`catalogCard__priceCurrent`}>{Number(el.card_price).toLocaleString('ru')} ₽</span>
                <div className={`catalogCard__priceOldContainer`}>
                    <span className={`catalogCard__priceOld`}>{Number(el.price).toLocaleString('ru')} ₽</span>
                    {el.card_discount !== null && (
                        <div className={`catalogCard__discountMarker discountMarker`}
                             style={{
                                 color: `${el.marker_discount_color}`,
                                 backgroundColor: `${el.marker_discount_bg_color}`
                             }}
                        >
                            {`-${el.card_discount}%`}
                        </div>
                    )}
                </div>
            </div>
        } else if (el.card_price === null) {
            return <div className={`catalogCard__priceContainer`}>
                <span className={`catalogCard__priceCurrent`}>Нет в наличии</span>
            </div>
        } else {
            return <div className={`catalogCard__priceContainer`}>
                <span className={`catalogCard__priceCurrent`}>{Number(el.card_price).toLocaleString('ru')} ₽</span>
            </div>
        }
    };

    const cardButtons = () => {
        // Если продукт не доступен
        if (el.status === null) {
            return (<div className={`button button--white button--disabled button--outOfStock`}>Не доступно</div>);
        }

        // Если нет продукта
        if (el.card_price === null) {
            return (
                <>
                    <button
                        className={`button button--addToWaitList${isAddingToWaitList ? ' load' : ''}`}
                        onClick={() => addToWaitList({productId: el.id})}
                    >
                        В лист ожидания
                    </button>
                    <button className={`button button--quickView`} onClick={() => openQuickView(el.article)}>
                        <Svg id={`quick-view`} className={`svg--quickView`} />
                    </button>
                </>
            );
        } else {
            return (
                <>
                    {basketProducts.some((ls) => ls.product_id === el.id) ?
                        <BasketButton className={`button button--gradient button--addToCart`}>В корзине</BasketButton>
                        :
                        <button
                            className={`button button--gradient button--addToCart${isAddingToBasket ? ' load' : ''}`}
                            onClick={() => addToBasket({
                                productId: el.id,
                                productDataId: null,
                                article: el.article,
                                price: currentPrice
                            })}
                        >
                            В корзину
                        </button>
                    }
                    <button className={`button button--quickView`} onClick={() => openQuickView(el.article)}>
                        <Svg id={`quick-view`} className={`svg--quickView`} />
                    </button>
                </>
            );
        }
    };

    // const YandexContainer = () => {
    //     const style = {
    //         display: 'flex',
    //         flexDirection: 'column',
    //         // alignItems: 'center',
    //         gap: '8px',
    //         marginBottom: '12px',
    //     };
    //
    //     let bnplSize = 'l', cashbackSize = 'm';
    //     if (isMobile()) {
    //         bnplSize = 'm';
    //         cashbackSize = 's';
    //     }
    //
    //     return <div style={style}>
    //         <yandex-pay-badge
    //             type={`bnpl`}
    //             amount={el.price_split_full}
    //             size={bnplSize}
    //             variant={`simple`}
    //             theme={`light`}
    //             merchant-id={`a8094f84-fddd-47df-a6af-28faabbb9e6c`}
    //         />
    //         <yandex-pay-badge
    //             type={`cashback`}
    //             amount={el.price_split_full}
    //             size={cashbackSize}
    //             variant={`default`}
    //             theme={`light`}
    //             merchant-id={`a8094f84-fddd-47df-a6af-28faabbb9e6c`}
    //         />
    //     </div>
    // }

    const cardBody = () => {
        return <>
            {el.status !== null && (
                <>
                    <div className={`catalogCard__markers`}>
                        {el.sticker && (
                            <img src={el.sticker} alt={el.sticker} className={`sticker`} />
                        )}
                    </div>
                    <div className={`catalogCard__heart`}>
                        <FavoritesCheckbox {...props} el={{...el, currentPrice: currentPrice}} />
                    </div>
                </>
            )}
            <Link
                href={`/catalog/product/${el.article}`}
                title={el.h1 + ' ' + el.article}
                onClick={() => handleItemClick()}
                className={`catalogCard__image`}
            >
                {type === 'catalog' ?
                    <Slider media={media} alt={el.h1 + ' ' + el.article} />
                    :
                    <Picture
                        src={el.img}
                        alt={el.h1 + ' ' + el.article}
                        width={`290`}
                        height={`290`}
                        imageClassName={`increase`}
                    />
                }
            </Link>
            <div className={`catalogCard__content`}>
                <PriceMinimum {...props} />
                {cardPrice()}
                {/*<YandexContainer />*/}
                <Link
                    href={`/catalog/product/${el.article}`}
                    className={`catalogCard__name truncate`}
                    onClick={() => handleItemClick()}
                >
                    {el.h1}
                </Link>
                {el.ratingCount !== null ?
                    <div className={`catalogCard__rating`}>
                        <Svg id={`star`} className={`svg--catalogCardStar`} />
                        <div className={`catalogCard__averageRating`}>{ratingAVG}</div>
                        <div className={`catalogCard__ratingDot`}></div>
                        <div className={`catalogCard__countReviews`}>
                            {el.ratingCount} {declOfNum(el.ratingCount, [' отзыв', ' отзыва', ' отзывов'])}
                        </div>
                    </div>
                    :
                    <div className={`catalogCard__rating`}>
                        <Svg id={`star`} className={`svg--catalogCardStarNotRating`} />
                        <p className={`catalogCard__notRating`}>Нет оценок</p>
                    </div>
                }
            </div>
        </>
    };

    return (
        <div ref={ref} className={classNames('catalogCard', className)}>
            <div className={`catalogCard__item`}>
                {cardBody()}
                <div className={`catalogCard__buttons`}>
                    {cardButtons()}
                </div>
            </div>
        </div>
    );
}

const Slider = ({media = [], alt = ''}) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const videoRef = useRef(null);

    // media = [
    //     'https://ir-3.ozone.ru/s3/multimedia-1-k/wc500/7372725464.jpg',
    //     'https://ir-3.ozone.ru/s3/multimedia-1-i/wc500/7337178882.jpg',
    //     'https://ir-3.ozone.ru/s3/multimedia-1-r/wc500/7372989819.jpg',
    //     'https://ir-3.ozone.ru/s3/multimedia-1-q/wc500/7269154694.jpg',
    //     'https://ir-3.ozone.ru/s3/multimedia-1-o/wc500/7425332088.jpg',
    // ];

    // Функция для смены изображения/видео
    const changeMedia = (index) => {
        setActiveIndex(index);
        if (media[index].endsWith(".mp4") && videoRef.current) {
            videoRef.current.load(); // Обновляем видео
        }
    };

    // Обработчики свайпа
    const handlers = useSwipeable({
        onSwipedLeft: () => setActiveIndex((prev) => (prev + 1) % media.length),
        onSwipedRight: () => setActiveIndex((prev) => (prev - 1 + media.length) % media.length),
        preventScrollOnSwipe: true,
        trackMouse: true,
    });

    return (
        <div {...handlers} className={`catalogCard__mediaBox`} onMouseOut={() => setActiveIndex(0)}>
            {media[activeIndex].endsWith(".mp4") ? (
                <video ref={videoRef}
                       playsInline
                       src={media[activeIndex]}
                       className={`catalogCard__video w-full h-full object-cover rounded-lg`}
                       autoPlay
                       loop
                       muted
                />
            ) : (
                <picture className={`catalogCard__picture`}>
                    <img loading={`eager`}
                         fetchpriority={`high`}
                         src={media[activeIndex]}
                        // srcSet={media[activeIndex] + ' 2x'}
                         alt={alt}
                         className={`catalogCard__image w-full h-full object-cover rounded-lg transition-opacity duration-300`}
                    />
                </picture>
            )}
            <div className={`catalogCard__hiddenBox`}>
                {media.map((_, index) => (
                    <div key={index} className={`catalogCard__hiddenBoxItem`} onMouseEnter={() => changeMedia(index)} />
                ))}
            </div>
            <div className={`catalogCard__dots`}>
                {media.map((_, index) => (
                    <div key={index} className={`catalogCard__dotsItem${index === activeIndex ? ' active' : ''}`} />
                ))}
            </div>
        </div>
    );
};

export default CatalogCard;
